import React from 'react';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList, buildServiceSchema } from '../lib/structuredData';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, ShieldIcon, ZapIcon, DatabaseIcon, ActivityIcon, CheckCircleIcon, ServerIcon, LockIcon, TrendingUpIcon, RefreshCwIcon, MailIcon, ShoppingCartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const HostingPage: React.FC = () => {
  const hostingFeatures = [{
    icon: <RefreshCwIcon className="h-6 w-6" data-id="element-1742" data-mp="3twt8i2xrtsgg" />,
    title: 'Managed hosting en updates',
    description: "Wij draaien de updates van WordPress, thema's en plugins op een rustig moment. Jij hoeft niet bang te zijn dat je site er kapot van gaat."
  }, {
    icon: <LockIcon className="h-6 w-6" data-id="element-1743" data-mp="23l5e8358exbk" />,
    title: 'SSL en beveiliging',
    description: 'SSL-certificaat ingeregeld en automatisch verlengd. Actieve beveiliging, malware-detectie en bescherming tegen ongewenste toegang.'
  }, {
    icon: <ZapIcon className="h-6 w-6" data-id="element-1744" data-mp="36xsavduibl0k" />,
    title: 'Snelheid en performance',
    description: 'Caching, image-optimalisatie en een server-stack die je bezoekers niet laat wachten, ook niet op piekmomenten.'
  }, {
    icon: <DatabaseIcon className="h-6 w-6" data-id="element-1745" data-mp="3fz04vjpzpzou" />,
    title: 'Backups en monitoring',
    description: 'Dagelijkse backups en 24/7 monitoring, zodat problemen vaak al opgelost zijn voordat jij ze opmerkt.'
  }];
  const inclusions = ['Managed WordPress hosting op onze eigen omgeving', 'SSL-certificaat, automatisch verlengd', 'Dagelijkse backups, 14 dagen bewaard', "Wekelijkse updates van WordPress, thema's en plugins", '24/7 monitoring met directe melding bij downtime', 'Anti-spam, antivirus en bot-bescherming', 'Razendsnelle laadtijden met caching en optimalisatie', 'Persoonlijk contact met het team dat je site bouwde'];
  const benefits = [{
    icon: <CheckCircleIcon className="h-6 w-6" data-id="element-1746" data-mp="7hvm59hv3ois" />,
    title: 'Hosting voor financieel adviseurs',
    description: 'Speciaal afgestemd op zakelijke dienstverleners die op een veilige en stabiele site moeten kunnen vertrouwen.'
  }, {
    icon: <ServerIcon className="h-6 w-6" data-id="element-1747" data-mp="35c00od7aadgo" />,
    title: 'Webhosting voor administratiekantoren',
    description: 'Betrouwbaar, met garantie op uptime en snelheid, op een omgeving die wij zelf onderhouden.'
  }, {
    icon: <ActivityIcon className="h-6 w-6" data-id="element-1748" data-mp="3f2kvrqnr0zuu" />,
    title: 'Hosting op maat voor MKB',
    description: 'Flexibele oplossing die meegroeit met je bedrijf, zonder dat je over moet stappen.'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-1749" data-mp="3oxmkile43zww" />,
    title: 'Betere afstemming met SEO',
    description: 'Technische SEO-optimalisaties voeren we direct door, zonder discussie met een externe partij.'
  }, {
    icon: <MailIcon className="h-6 w-6" data-id="element-1750" data-mp="1tovtwictvbb" />,
    title: 'Zakelijke e-mail naast je hosting',
    description: 'Combineer je hosting met onze e-mail pakketten (Starter, Premium of Google Workspace) voor één compleet pakket.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1751" data-mp="1w2bw17cggwee">
      <SEO title="Zakelijke hosting voor €34,99 per maand | Noord Digital" description="Managed hosting voor zakelijke websites, vaste prijs van €34,99 per maand. Inclusief SSL, dagelijkse backups, 24/7 monitoring en wekelijkse updates. Geschikt voor financieel adviseurs, administratiekantoren en zakelijke dienstverleners." keywords="managed hosting, zakelijke hosting, hosting financieel adviseur, webhosting administratiekantoor, SSL certificaat, dagelijkse backups, WordPress hosting, hosting MKB" canonical="https://noorddigital.nl/hosting" jsonLd={[buildServiceSchema({
      name: 'Hosting',
      description: 'Beheerde hosting voor zakelijke websites met dagelijkse back-ups, updates, monitoring en een vast aanspreekpunt.',
      path: '/hosting',
      serviceType: 'Managed webhosting'
    }), buildBreadcrumbList([{
      name: 'Hosting',
      path: '/hosting'
    }])]} data-id="element-1752" data-mp="1w3n3bh540ma9" />
      <Header data-id="element-1753" data-mp="pkouh7k3o8s8" />

      {/* Hero */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-20 relative overflow-hidden" data-id="element-1754" data-mp="2diy11af0bxkd">
        <div className="absolute inset-0 opacity-20" data-id="element-1755" data-mp="2ia6ag6gc7ixj">
          <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center" data-id="element-1756" data-mp="2ibr3tsqx0vtt"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-1757" data-mp="28k4njhzq06k7">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-1758" data-mp="2wa8lb8q89c3a">
            <div className="lg:col-span-7" data-id="element-1759" data-mp="3177ik056tz5p">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-1760" data-mp="2n8rbg83ey6n1">
                Managed hosting voor zakelijke websites, €34,99 per maand
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-white text-opacity-90 mb-8 text-lg leading-relaxed" data-id="element-1761" data-mp="18benavj8sz11">
                Eén vaste prijs, geen verrassingen achteraf. Wij hosten je website op onze eigen omgeving, regelen SSL, backups, monitoring en updates, en zijn bereikbaar als er iets is. Geschikt voor financieel adviseurs, administratiekantoren en andere zakelijke dienstverleners, in{' '}
                <a href="/werkgebied/alkmaar" className="underline underline-offset-4 decoration-white/50 hover:decoration-white transition-colors duration-200" data-id="element-1762" data-mp="zbi5ndv9t0fh">Alkmaar</a>{' '}
                en de rest van Noord-Holland Noord.
              </motion.p>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-wrap gap-4" data-id="element-1763" data-mp="6skvcd31zi9r">
                <motion.a href="#hosting-prijs" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg group" data-id="element-1764" data-mp="vjs4x4efih9l">
                  Bekijk wat erbij zit
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1765" data-mp="8myrd6vheb0a" />
                </motion.a>
                <motion.a href="/websites" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-transparent border-2 border-white text-white font-semibold rounded-lg group" data-id="element-1766" data-mp="hl0xg0u2ntuf">
                  Website laten maken
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1767" data-mp="1xyr4ngghmy8a" />
                </motion.a>
              </motion.div>
            </div>

            {/* Prijs-card */}
            <div className="lg:col-span-5" data-id="element-1768" data-mp="3dk2rcjuuk58m">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white rounded-2xl p-8 shadow-2xl relative" data-id="element-1769" data-mp="38s1kxekd18qi">
                <div className="absolute -top-4 left-6 inline-flex items-center gap-2 bg-[#007AFF] text-white text-xs font-semibold uppercase tracking-wide px-3 py-1.5 rounded-full shadow-md" data-id="element-1770" data-mp="2urqqy2nr7e14">
                  <ShieldIcon className="h-3 w-3" data-id="element-1771" data-mp="2kucesf8v5bem" />
                  Vaste prijs, alles inbegrepen
                </div>
                <div className="text-center mb-6" data-id="element-1772" data-mp="o0rbjbxce3zy">
                  <p className="text-[#6B7280] text-sm uppercase tracking-wide mb-2" data-id="element-1773" data-mp="nzg6z9w2os7s">
                    Vanaf
                  </p>
                  <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-1774" data-mp="3o29ehs95d9uj">
                    <span className="text-6xl md:text-7xl font-bold text-[#111827]" data-id="element-1775" data-mp="3t1kwf4l92ldp">
                      €34,99
                    </span>
                  </div>
                  <p className="text-[#6B7280] text-sm" data-id="element-1776" data-mp="3fa7ge0mjw5nf">per maand, excl. BTW</p>
                </div>

                <div className="space-y-3 pt-6 border-t border-gray-200 mb-6" data-id="element-1777" data-mp="3j9yb2ff775x8">
                  <div className="flex items-center gap-3" data-id="element-1778" data-mp="35aow1j2qahuu">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1779" data-mp="3abw4zlglxn33" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1780" data-mp="2wbv1rzcve3kg">
                      SSL-certificaat en wekelijkse updates inbegrepen
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1781" data-mp="30f02pxhaxx6z">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1782" data-mp="uljkee93uan0" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1783" data-mp="yksdri08g6i1">
                      Dagelijkse backups en 24/7 monitoring
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1784" data-mp="2f2suu9123qa5">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1785" data-mp="2f06cdecmnqd5" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1786" data-mp="2suyxcsbadyr4">
                      99,9 procent uptime garantie
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1787" data-mp="32r2aet7ofhsu">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1788" data-mp="32toeujz9th6u" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1789" data-mp="2xuv2iuvpzw89">
                      Persoonlijk contact, geen ticketsysteem
                    </span>
                  </div>
                </div>

                <a href="/#contact" className="inline-flex items-center justify-center w-full bg-[#007AFF] text-white font-semibold py-3 px-6 rounded-lg shadow-md" data-id="element-1790" data-mp="36rceg0bwry52">
                  Vraag hosting aan
                  <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-1791" data-mp="1chimrj4f7zrx" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Wat zit er inbegrepen */}
      <div id="hosting-prijs" className="w-full bg-white py-20 md:py-24" data-id="element-1792" data-mp="qoyijf1p0xwn">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1793" data-mp="mlsd29menar8">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1794" data-mp="hn7bo6vf2l17">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1795" data-mp="1ec6mntndy0x3">
              Wat zit er bij die €34,99 per maand?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1796" data-mp="10k8k61o6j39w">
              Geen onderdelen die later los gefactureerd worden. Alles wat een zakelijke website nodig heeft om veilig en snel te blijven, zit erin.
            </motion.p>
          </div>

          <div className="max-w-4xl mx-auto bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 md:p-12 mb-12" data-id="element-1797" data-mp="2ai8axzjurlf2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1798" data-mp="2elxxykkvpuxz">
              {inclusions.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1799" data-mp="2jjfybmktz1ud" data-mpi={i}>
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF] mt-0.5 flex-shrink-0" data-id="element-1800" data-mp="2ohr67rrkf29y" />
                  <span className="text-[#6B7280] leading-relaxed" data-id="element-1801" data-mp="2t997kgxi34vg">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1802" data-mp="2y7stwig0aioc">
            {hostingFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-8 transition-all duration-300 group" data-id="element-1803" data-mp="3284drt0joeyr" data-mpi={index}>
                <div className="flex items-start gap-4" data-id="element-1804" data-mp="1c52qhj68hjfl">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className="flex-shrink-0 w-12 h-12 bg-[#007AFF] rounded-full flex items-center justify-center text-white" data-id="element-1805" data-mp="1qv079e1u36ur">
                    {feature.icon}
                  </motion.div>
                  <div className="flex-1" data-id="element-1806" data-mp="1ztc9kdc2bt31">
                    <h3 className="font-bold text-[#111827] text-xl mb-2" data-id="element-1807" data-mp="1uwdcpn10l815">
                      {feature.title}
                    </h3>
                    <p className="text-[#6B7280] leading-relaxed" data-id="element-1808" data-mp="5hxh3oro3fjl">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Waarom hosting bij Noord Digital */}
      <div className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-1809" data-mp="2h493dnipk8k2">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1810" data-mp="23d49z35xoci6">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1811" data-mp="27e62z299bsbp">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1812" data-mp="1tfpvva7hfzt1">
              Waarom hosting bij Noord Digital?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1813" data-mp="1oh4vnas8dg4l">
              Bij veel hostingpartijen ben je een nummer. Bij ons krijg je persoonlijke aandacht, proactief onderhoud en een team dat je website kent. Hosting, website en SEO onder één dak betekent snellere doorvoering en betere resultaten.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1814" data-mp="2f5fvhlg90s6h">
            {[{
            stat: '99,9%',
            label: 'Uptime garantie',
            description: 'Je website is altijd bereikbaar voor je klanten. Mocht er toch iets misgaan, dan zijn wij er direct bij.'
          }, {
            stat: '< 1s',
            label: 'Gemiddelde laadtijd',
            description: 'Snelle websites ranken beter in Google en zorgen voor een betere gebruikerservaring.'
          }, {
            stat: '24/7',
            label: 'Monitoring en support',
            description: 'We houden je website dag en nacht in de gaten. Problemen worden vaak opgelost voordat je ze merkt.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-white rounded-2xl p-8 shadow-lg text-center" data-id="element-1815" data-mp="2whbkhwzryrn" data-mpi={index}>
                <div className="text-4xl md:text-5xl font-bold text-[#007AFF] mb-2" data-id="element-1816" data-mp="guo19arsesg8">
                  {item.stat}
                </div>
                <div className="text-lg font-bold text-[#111827] mb-3" data-id="element-1817" data-mp="3kcz8tz83popa">
                  {item.label}
                </div>
                <p className="text-[#6B7280] leading-relaxed text-sm" data-id="element-1818" data-mp="3pc25ava0mmln">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1819" data-mp="2wooap3tsi34p">
            {[{
            title: 'Alles onder één dak',
            description: 'Website, hosting, SEO en e-mail bij één partij. Snellere communicatie, betere afstemming, geen gedoe met verschillende leveranciers.'
          }, {
            title: 'Proactief onderhoud',
            description: 'We wachten niet tot er iets misgaat. Updates, beveiligingspatches en optimalisaties worden automatisch en regelmatig uitgevoerd.'
          }, {
            title: 'Schaalbaar wanneer je groeit',
            description: 'Van een eenvoudige website tot een uitgebreide webshop, onze hosting groeit mee zonder dat je hoeft te migreren.'
          }, {
            title: 'Persoonlijk contact',
            description: 'Geen ticketsystemen of chatbots. Je hebt direct contact met het team dat je website heeft gebouwd en beheert.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 flex items-start gap-4 shadow-sm border border-gray-100" data-id="element-1820" data-mp="2fm0roc28jz78" data-mpi={index}>
                <div className="w-8 h-8 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1821" data-mp="1htsqjpl8muq0">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF]" data-id="element-1822" data-mp="13v2rw5irsmzj" />
                </div>
                <div data-id="element-1823" data-mp="18t4l3j9wu2oq">
                  <h3 className="font-bold text-[#111827] text-lg mb-1" data-id="element-1824" data-mp="18up54eylm38c">
                    {item.title}
                  </h3>
                  <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-1825" data-mp="20jiscwnf4grf">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center mt-12" data-id="element-1826" data-mp="1rr73vgbv73e3">
            <p className="text-[#6B7280] mb-4" data-id="element-1827" data-mp="2k9ukaifx1u8u">
              Benieuwd wat hosting bij Noord Digital voor jouw website kan betekenen?
            </p>
            <motion.a href="/#contact" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center bg-[#007AFF] text-white font-semibold py-3 px-8 rounded-lg shadow-md group" data-id="element-1828" data-mp="feicubl31y4f">
              Vraag een vrijblijvend gesprek aan
              <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1829" data-mp="134misplqu9yl" />
            </motion.a>
          </motion.div>
        </div>
      </div>

      {/* Norden SSL */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1830" data-mp="t5f2punmk17s">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1831" data-mp="t81bfxm94mrl">
          <div className="max-w-4xl mx-auto" data-id="element-1832" data-mp="p4bp7et1uh9q">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-2xl p-8 md:p-12 text-white shadow-xl" data-id="element-1833" data-mp="3dwxdot1beou8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1834" data-mp="1tfeqwdh8r0jv">
                <div className="text-center md:text-left" data-id="element-1835" data-mp="1ycy91oh27xh3">
                  <div className="inline-block relative" data-id="element-1836" data-mp="1ybn25fsbi9lr">
                    <motion.div initial={{
                    opacity: 0,
                    scale: 0.8
                  }} whileInView={{
                    opacity: 1,
                    scale: 1
                  }} viewport={{
                    once: true
                  }} transition={{
                    type: 'spring',
                    stiffness: 100
                  }} className="w-40 h-40 bg-white bg-opacity-20 rounded-full flex items-center justify-center p-4 relative overflow-hidden backdrop-blur-sm" data-id="element-1837" data-mp="234yc3psff6hw">
                      <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden regelt SSL certificaat en updates" className="w-full h-full object-cover" data-id="element-1838" data-mp="ms166vm79zes" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, 5, 0]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} className="absolute -top-2 -right-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1839" data-mp="gguncy2lfpqs">
                      <LockIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1840" data-mp="uavbkxvx5ucw" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, -360]
                  }} transition={{
                    y: {
                      duration: 4,
                      repeat: Infinity
                    },
                    rotate: {
                      duration: 10,
                      repeat: Infinity,
                      ease: 'linear'
                    }
                  }} className="absolute -bottom-2 -left-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1841" data-mp="z9yiyozdgco1">
                      <RefreshCwIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1842" data-mp="1na0kbfjvlvfi" />
                    </motion.div>
                  </div>
                </div>
                <div data-id="element-1843" data-mp="1eb5c5xx9ub9k">
                  <motion.h2 initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} className="font-bold text-white text-3xl mb-4" data-id="element-1844" data-mp="1ebolwrcrptci">
                    Norden regelt je SSL en je updates
                  </motion.h2>
                  <motion.p initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.1
                }} className="text-white text-opacity-90 text-lg leading-relaxed mb-6" data-id="element-1845" data-mp="1x269khiqtyr0">
                    Geen gedoe met technische zaken. Norden zorgt automatisch voor je SSL-certificaat, draait updates op een rustig moment en houdt alles veilig. Jij focust op je klanten.
                  </motion.p>
                  <div className="space-y-3" data-id="element-1846" data-mp="j10dbe7s7tgf">
                    <div className="flex items-center gap-3" data-id="element-1847" data-mp="j3wd7836ws7i">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1848" data-mp="4c3xuw3ebe5s" />
                      <span className="text-white text-opacity-90" data-id="element-1849" data-mp="93vu9n98ge3u">
                        Automatische SSL-installatie en verlenging
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1850" data-mp="3viotkt4eba95">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1851" data-mp="3vgu9fh0y7m64" />
                      <span className="text-white text-opacity-90" data-id="element-1852" data-mp="3hk79r6hm2hwi">
                        Wekelijkse updates van WordPress en plugins
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1853" data-mp="32wywm04qs2hw">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1854" data-mp="2xyfanzq5eqpj" />
                      <span className="text-white text-opacity-90" data-id="element-1855" data-mp="3cvfpx3r5kt74">
                        Proactieve beveiligingscontroles
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Voor wie + cross-sell */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1856" data-mp="3gvyjp3clw9by">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1857" data-mp="3vlxfx0klpaos">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1858" data-mp="3qmb2or4rvufz">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1859" data-mp="3qmt5k6lxx6wv">
              Voor wie werkt deze hosting goed?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed mb-8" data-id="element-1860" data-mp="22wn0ks6ocruw">
              Naast standaard webhosting hebben we ook ervaring met webshops, WooCommerce en maatwerk-applicaties. Ons hostingpakket groeit mee.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex items-center justify-center gap-3 mb-8" data-id="element-1861" data-mp="1jzvlkuy60ywn">
              <ShoppingCartIcon className="h-8 w-8 text-[#007AFF]" data-id="element-1862" data-mp="34dm7zxfi8iim" />
              <span className="text-[#6B7280] font-medium" data-id="element-1863" data-mp="34fytgkkh1b0f">
                Geschikt voor WooCommerce en maatwerk
              </span>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1864" data-mp="opgvkkbwa3w8">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-6 transition-all duration-300 group" data-id="element-1865" data-mp="jwnt633wf7nb" data-mpi={index}>
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="w-12 h-12 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-1866" data-mp="3s6fl39y3uki3">
                  {benefit.icon}
                </motion.div>
                <h3 className="font-bold text-[#111827] text-lg mb-2" data-id="element-1867" data-mp="29j5ym3e315kh">
                  {benefit.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-1868" data-mp="2eanzkrg3v65g">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 max-w-3xl mx-auto mt-12" data-id="element-1869" data-mp="25hc3sbqkivs8">
            <h3 className="font-bold text-[#111827] text-xl mb-4 text-center" data-id="element-1870" data-mp="2j8pgb5q26tdr">
              Compleet pakket bij één partij
            </h3>
            <p className="text-[#6B7280] text-center mb-6" data-id="element-1871" data-mp="2o6io2370fvg5">
              Combineer je hosting met onze andere diensten voor een professionele online aanwezigheid.
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-1872" data-mp="1cswzok8z5xvo">
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1873" data-mp="15947l82zv6rj">
                Onepager vanaf €499
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1874" data-mp="19aps9flrspca" />
              </motion.a>
              <motion.a href="/email" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1875" data-mp="lkdbrgcglka3">
                Zakelijke e-mail vanaf €1,99
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1876" data-mp="qjzlvgwzqkeo" />
              </motion.a>
              <motion.a href="/seo" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1877" data-mp="2t2k2wywt3h5">
                SEO optimalisatie
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1878" data-mp="3dh8eu6z1xqfe" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#005FCC] py-20 md:py-24" data-id="element-1879" data-mp="3ng7fp3dkshru">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1880" data-mp="3sdh90u435dky">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1881" data-mp="8vl4w9y3lu2">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-white text-3xl md:text-4xl mb-6" data-id="element-1882" data-mp="516kny0rx5m3">
              Eerlijk geprijsd, alles inbegrepen
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-white text-opacity-90 text-lg leading-relaxed mb-8" data-id="element-1883" data-mp="jyyymlqo9ly6">
              €34,99 per maand, geen verrassingen, geen losse posten voor SSL of backups. Wij hosten je website op onze eigen omgeving, jij hebt er geen omkijken naar.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex flex-wrap gap-4 justify-center" data-id="element-1884" data-mp="2n66eeov1egl9">
              <motion.a href="/#contact" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg group" data-id="element-1885" data-mp="28hjndpw1s0e7">
                Neem contact op
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1886" data-mp="6q8eujqq8bbo" />
              </motion.a>
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg group" data-id="element-1887" data-mp="fqofllg354cu">
                Website laten maken
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1888" data-mp="kq0zpyfknxbq" />
              </motion.a>
            </motion.div>
          </div>
        </div>
      </div>

      <Footer data-id="element-1889" data-mp="ufsyz5ym9emj" />
    </div>;
};